module.exports = __webpack_public_path__ + "img/google_auth.003f02fa.png";